import React from "react";
import useInView from "../../../hooks/useInView";
import "./TarjetaDeServicioIa.css";

interface ServiceItem {
  title: string;
  desc: string;
}

interface TarjetaDeServicioProps {
  service: ServiceItem;
  delay?: number;
  animationClass?: string;
}

export default function TarjetaDeServicio({ service, delay = 0, animationClass = "" }: TarjetaDeServicioProps) {
  const [ref, inView] = useInView({ threshold: 0.3 });

  return (
    <div
      ref={ref}
      className={`serviceia-card animate-card${inView ? " visible" : ""} ${animationClass}`}
      style={{ transitionDelay: `${delay}s` } as React.CSSProperties}
    >
      <h3 className="serviceia-card-title">{service.title}</h3>
      <p className="serviceia-card-text">{service.desc}</p>
    </div>
  );
}